export default "__VITE_ASSET__BbHMRU5C__"